<template>
    <div class="kgr-inputGroup kgr-inputGroup--constrainedWidth">
        <kgr-form-row
            :label="$t('member.firstName')"
            :error="error"
            field-name="firstName"
            required
        >
            <input
                v-model.trim="member.firstName"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('member.lastName')"
            :error="error"
            field-name="lastName"
            required
        >
            <input
                v-model.trim="member.lastName"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('member.gender')"
            :error="error"
            field-name="gender"
        >
            <kgr-gender-select
                v-model="member.gender"
                as-input
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('member.dateOfBirth')"
            :error="error"
            field-name="dateOfBirth"
            :tooltip="$t('Format: TT.MM.JJJJ')"
        >
            <kgr-date-picker
                v-model.trim="member.dateOfBirth"
                @enter="onKeyUpEnter"
            />
        </kgr-form-row>
    </div>
</template>

<script>

import DatePicker from '../common/form/picker/DatePicker';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';
import GenderSelect from '../common/form/select/GenderSelect';
import Member from '../../js/dto/Member';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-gender-select': GenderSelect,
        'kgr-date-picker': DatePicker,
    },
    props: {
        member: {
            type: Member,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
